<template>
	<main-container v-if="$hasRole('admin') || $hasRole('owner')">
		<v-row dense>
			<v-col cols="6" xs="6" :sm="$hasRole('admin') ? 6 : 10">
				<h3 class="primary--text">{{ $t("global.appname") }}</h3>
			</v-col>
			<v-col cols="6" xs="6" sm="4" v-if="$hasRole('admin')">
				<v-combobox hide-details v-model="client" :label="$t('incomedeclarations.tenant')" :items="$appOptions.autocompleteAdminClients()" @change="loadSimulatorData()" item-text="fullname" item-value="id" :menu-props="'closeOnClick, overflowY'"></v-combobox>
			</v-col>
			<v-col cols="6" xs="6" sm="2">
				<v-select hide-details :label="$t('incomedeclarations.ref_year')" :items="$appOptions.years()" v-model="year" @change="loadSimulatorData()"></v-select>
			</v-col>
		</v-row>
		<v-row dense>
			<v-col cols="12" xs="12">
				<v-row align="center">
					<v-col cols="auto">
						<h4>Dati della simulazione</h4>
					</v-col>
					<v-col>
						<v-divider class="my-0"></v-divider>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" xs="12" sm="6">
				<material-stats :min-height="$vuetify.breakpoint.xsOnly ? null : '380px'" title="Fatturato" icon="fas fa-euro-sign" color="primary" infoicon="far fa-circle-question" :infotext="$t('simulator.invoiced_info') + ' ' + $t('simulator.deposit_info')">
					<v-row dense slot="fields">
						<v-col cols="12" xs="12" sm="6">
							<price-field :name="$t('simulator.invoiced')" :value="formattedInvoiced" disabled></price-field>
						</v-col>
						<v-col cols="12" xs="12" sm="6">
							<price-field :name="$t('simulator.prevision_and_invoiced')" :value="formattedPrevisionAndInvoiced" disabled></price-field>
						</v-col>
						<v-col cols="12" xs="12">
							<v-slider v-model="invoicePrevision" :label="$t('simulator.prevision')" @change="(value) => updateInvoicePrevision(value)" min="0" max="85000" step="500">
								<template v-slot:append>
									<span style="min-width: 100px" v-html="formattedInvoicePrevision"></span>
								</template>
							</v-slider>
						</v-col>
						<v-col cols="12" xs="12">
							<strong>Acconti versati:</strong>
						</v-col>
						<v-col cols="12" xs="12" v-for="(el, index) in formattedDeposit" :key="index">
							<span class="ml-2">{{ el.first }}: {{ el.second }}</span>
						</v-col>
					</v-row>
				</material-stats>
			</v-col>
			<v-col cols="12" xs="12" sm="6">
				<material-stats :min-height="$vuetify.breakpoint.xsOnly ? null : '380px'" title="Dati" :elements="formattedTenantData" icon="fas fa-laptop-house" color="primary" infoicon="far fa-circle-question" :infotext="$t('simulator.tenant_data_info')"></material-stats>
			</v-col>
			<v-col cols="12" xs="12">
				<v-row align="center">
					<v-col cols="auto">
						<h4>Risultato simulazione</h4>
					</v-col>
					<v-col>
						<v-divider class="my-0"></v-divider>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" xs="12" sm="6">
				<material-stats :min-height="$vuetify.breakpoint.xsOnly ? null : '400px'" title="Scadenze" icon="far fa-calendar-days" color="primary" infoicon="far fa-circle-question" :infotext="$t('simulator.deadlines_info')">
					<v-row dense slot="fields">
						<v-col cols="12" xs="12">
							<v-expansion-panels flat>
								<v-expansion-panel v-for="(item, i) in formattedDeadlines" :key="i">
									<v-expansion-panel-header expand-icon="fas fa-angle-down"><div v-html="item.total"></div></v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-row dense>
											<v-col cols="12" xs="12" v-for="(el, index) in item.details" :key="index" class="text--secondary">
												<strong v-if="el.first">{{ el.first }}:</strong>
												<span class="ml-2">{{ el.second }}</span>
											</v-col>
										</v-row>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-col>
					</v-row>
				</material-stats>
			</v-col>
			<v-col cols="12" xs="12" sm="6">
				<material-stats :min-height="$vuetify.breakpoint.xsOnly ? null : '400px'" title="Incidenza imposte e contributi" icon="far fa-calendar-days" color="primary">
					<template slot="graph">
						<GChart v-if="graphtype" :type="graphtype" :data="graphdata" :options="graphoptions" :settings="{ packages: ['corechart'], language: 'it' }" />
					</template>
				</material-stats>
			</v-col>
		</v-row>
	</main-container>
	<main-container v-else>
		<material-card icon="fas fa-face-smile-wink" :title="$t('user.welcome')">
			<span slot="after-heading">{{ $t("user.welcome_message") }}</span>
		</material-card>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		year: null,
		client: null,
		graphoptions: {
			animation: {
				startup: true,
				duration: 1000,
				easing: "in",
			},
			curveType: "function",
			backgroundColor: "transparent",
			height: 280,
			chartArea: {
				width: "80%",
				height: "70%",
			},
			series: {},
			vAxes: {
				0: {
					logScale: false,
					viewWindow: {
						min: 0,
					},
					textStyle: {
						color: "black",
					},
				},
				1: {
					logScale: false,
					viewWindow: {
						min: 0,
					},
					textStyle: {
						color: "black",
					},
				},
			},
			hAxis: {
				textStyle: {
					color: "black",
				},
			},
			timeline: {
				groupByRowLabel: true,
			},
			legend: {
				position: "bottom",
				textStyle: {
					color: "black",
				},
			},
			isStacked: "percent",
		},
		invoicePrevision: 0,
	}),
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		formattedTenantData() {
			let data = [
				{ first: this.$t("tenant.fullname"), second: null },
				{ first: this.$t("tenant.redditivity"), second: null },
				{ first: this.$t("tenant.aliquota_imposta_sostitutiva"), second: null },
				{ first: this.$t("tenant.ateco"), second: null },
			];
			if (this.tenantstats.tenant) {
				data[0].second = this.tenantstats.tenant.fullname;
				data[1].second = this.tenantstats.tenant.redditivity + "%";
				data[2].second = this.tenantstats.aliquota_imposta_sostitutiva + "%";
				data[3].second = this.tenantstats.tenant.ateco;
			}
			return data;
		},
		formattedInvoiced() {
			let data = 0;
			if (this.tenantstats.simulation) {
				data = parseFloat(this.tenantstats.simulation.fatturato);
			}
			return data.toFixed(2);
		},
		formattedPrevisionAndInvoiced() {
			let data = 0;
			if (this.tenantstats.simulation) {
				data = parseFloat(this.tenantstats.simulation.fatturato) + parseFloat(this.tenantstats.simulation.prevision);
			}
			return data.toFixed(2);
		},
		formattedInvoicePrevision() {
			return this.$formatters.formatCurrency(this.invoicePrevision);
		},
		formattedDeadlines() {
			const self = this;
			let data = [];
			if (this.tenantstats.simulation) {
				Object.keys(this.tenantstats.simulation.deadlines).forEach((elkey) => {
					let el = this.tenantstats.simulation.deadlines[elkey];
					if (el.date != null) {
						data.push({ date: el.date, value: el.value, first: el.label, second: this.$formatters.formatCurrency(el.value) });
					}
				});
				if (data.length == 0) {
					return [{ total: "Nessuna scadenza", details: [{ second: "Inserisci i dati del fatturato e delle dichiarazioni passate per ottenere il risultato della simulazione" }] }];
				}
			}
			data = _.groupBy(data, "date");
			let finaldata = [];
			Object.keys(data).forEach((deadlineindex) => {
				let total = 0;
				data[deadlineindex].forEach((el) => {
					total += el.value;
				});
				finaldata.push({ total: "<strong class='mr-2'>" + self.$formatters.frontEndDateFormat(deadlineindex) + ":</strong>" + self.$formatters.formatCurrency(total), details: data[deadlineindex] });
			});
			return finaldata;
		},
		formattedDeposit() {
			let data = [];
			if (this.tenantstats) {
				if (this.tenantstats.simulation) {
					data.push({ first: "Imposte", second: this.$formatters.formatCurrency(this.tenantstats.simulation.acconti_impostasostitutiva_annoprecedente) });
					data.push({ first: "Contributi", second: this.$formatters.formatCurrency(this.tenantstats.simulation.acconti_gestioneseparata_annoprecedente) });
				}
			}
			return data;
		},
		graphdata() {
			let data = [];
			if (this.tenantstats.graphdata) {
				if (this.tenantstats.graphdata.content) {
					data = _.cloneDeep(this.tenantstats.graphdata.content);
					let series = {};
					Object.keys(data[0]).forEach((columnindex) => {
						if (columnindex > 0) {
							if (data[0][columnindex].color) {
								series[columnindex - 1] = { type: data[0][columnindex].graphtype, targetAxisIndex: data[0][columnindex].targetaxes, color: data[0][columnindex].color };
							} else {
								series[columnindex - 1] = { type: data[0][columnindex].graphtype, targetAxisIndex: data[0][columnindex].targetaxes };
							}
						}
					});
					this.graphoptions.series = series;
				}
			}
			return data;
		},
		graphtype() {
			if (this.tenantstats.graphdata) {
				if (this.tenantstats.graphdata.type && !_.isEmpty(this.graphdata)) {
					if (this.graphdata.length > 0) {
						this.graphoptions.seriesType = this.tenantstats.graphdata.seriesType;
						this.graphoptions.isStacked = this.tenantstats.graphdata.isStacked;
						return this.tenantstats.graphdata.type;
					}
				}
			}
			return null;
		},
		stats_loading() {
			return this.$store.getters.stats_loading;
		},
		tenantstats() {
			return this.$store.getters.getTenantstats;
		},
	},
	methods: {
		updateInvoicePrevision(prevision) {
			this.$store
				.dispatch("updateInvoicePrevision", {
					ref_year: this.year,
					prevision: prevision,
					tenant_id: this.tenantstats.tenant.id,
				})
				.then((res) => {
					this.loadSimulatorData();
				});
		},
		loadSimulatorData() {
			const self = this;
			let params = {
				year: this.year,
			};
			if (this.$hasRole("admin")) {
				if (!_.isEmpty(this.client)) {
					params.tenant_id = this.client.id;
				}
			}
			if (this.$hasRole("owner") || this.$hasRole("admin")) {
				this.$store.dispatch("getTenantStats", params).then((res) => {
					if (res.simulation) {
						self.invoicePrevision = res.simulation.prevision;
					}
				});
			}
		},
	},
	created() {
		if (this.$hasRole("admin") || this.$hasRole("owner")) {
			const self = this;
			this.year = moment().format("YYYY");
			if (this.$hasRole("admin")) {
				function waitLoadClients() {
					if (!_.isEmpty(self.$appOptions.autocompleteAdminClients())) {
						let clients = self.$appOptions.autocompleteAdminClients();
						if (!_.isEmpty(clients)) {
							self.client = clients[0];
						}
						self.loadSimulatorData();
					} else {
						setTimeout(function () {
							waitLoadClients();
						}, 200);
					}
				}
				waitLoadClients();
			} else {
				self.loadSimulatorData();
			}
		}
	},
};
</script>
